<template>
  <div class="container">
    <div class="comic-cover">
      <p :style="isMobile() ? 'font-weight:600;' : 'font-size:15px;'">{{ catchPhrase }}</p>
      <p class="comic-cover-title" style="font-size:15px;">{{ workName }}</p>
      <p :style="isMobile() ? 'font-weight:600;' : 'font-size:15px;'">{{ authorName }}</p>
      <p><br /></p>
      <p :style="isMobile() ? 'font-weight:600;' : 'font-size:12px;'">{{ storyTitle }}</p>
      <p :style="isMobile() ? 'font-weight:600;' : 'font-size:12px;'" class="comic-cover-scroll-guide">←←←右から左へ読み進めます</p>
      <div class="comic-cover-explanation" :style="isMobile() ? 'font-weight:600;display:none;' : 'font-size:11px;'">
        ▼ページ送り<br />　・左側ページをマウスクリック<br />　・左矢印キー<br />　・スペースキー<br />
        <br />
        ▼ページ戻り<br />　・右側ページをマウスクリック<br />　・右矢印キー<br />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "CoverPage",
    props: {
      catchPhrase: "",
      workName: "",
      authorName: "",
      storyTitle: "",
    },
  }
</script>

<style scoped>
  .container {
    background-color: white;
    width: 100%;
    height: 100%;
    text-align: center;
  }
  .comic-cover {
    /* Make the size match the parent element to clip the text. */
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    overflow: hidden;
    user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -webkit-user-select: none;

    /*
    　Adjust the display position etc. of the title.
    　It will balance even when the window size is small.
     */
    padding-top: 20%;
    font-size: larger;
  }

  .comic-cover-scroll-guide {
    padding-top: 1em;
  }

  .comic-cover-title {
    font-size: x-large;
    font-weight: bold;
    padding-left: 2px;
    padding-right: 2px;
  }

  .comic-cover-explanation {
    padding-top: 2em;
    font-size: smaller;
    text-align: left;
    display: inline-block;
  }

</style>


// WEBPACK FOOTER //
// src/components/CoverPage.vue